import React, { FC, ReactNode } from 'react';
import { Drawer, SwipeableDrawer, useMediaQuery, useTheme } from '@mui/material';
import { observer } from 'mobx-react';

import { useAppStore } from '../../../hooks/useAppStore';
import { SIDEBAR_DEFAULT_WIDTH, SIDEBAR_MIN_WIDTH } from '../../../types/sidebar';

interface AdaptiveDrawerProps {
    children: ReactNode;
    sx?: object;
}

const AdaptiveDrawer: FC<AdaptiveDrawerProps> = observer(({ children, sx }) => {
    const { isCollapsed, sidebarWidth, setCollapsed, setSidebarWidth, isResizing } = useAppStore();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const drawerSx = {
        width: sidebarWidth,
        flexShrink: 0,
        transition: isResizing ? 'none' : 'width 300ms ease-in-out',
        '& .MuiDrawer-paper': {
            width: sidebarWidth,
            boxSizing: 'border-box',
            borderRight: 'none',
            overflowX: 'hidden',
            position: 'relative',
            transition: isResizing ? 'none' : 'width 300ms ease-in-out',
        },
        ...sx,
    };

    // For mobile, use SwipeableDrawer
    if (isMobile) {
        return (
            <SwipeableDrawer
                anchor="left"
                open={!isCollapsed}
                onClose={() => {
                    setCollapsed(true);
                    setSidebarWidth(SIDEBAR_MIN_WIDTH);
                }}
                onOpen={() => {
                    setCollapsed(false);
                    setSidebarWidth(SIDEBAR_DEFAULT_WIDTH);
                }}
                sx={drawerSx}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile
                }}
            >
                {children}
            </SwipeableDrawer>
        );
    }

    // For desktop, use persistent Drawer
    return (
        <Drawer
            variant="permanent"
            open={true}
            sx={drawerSx}
        >
            {children}
        </Drawer>
    );
});

export default AdaptiveDrawer;

